export default "__VITE_ASSET__BcDxn3eP__"